import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { TraditumContent } from './components/TraditumContent';

export default function Traditum() {
    return (
        <>
            <MainContent
                component={<TraditumContent />}
                titulo='Gestión de Solicitudes Traditum'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
